jQuery(document).ready(function ($) {
    "use strict";
    initHeader();
    // ▼ HAUPTMENUE 
    //   ▶︎ Manni-Logo und Menu beim Scrollen animieren
    var $narrowMenu = new Waypoint({
        element: $('.header__trigger')[0],
        handler: function (direction) {
            if (direction == 'down') {
                $('header').addClass('narrow');
            } else {
                $('header').removeClass('narrow');
            }
        },
        offset: $('.navigation_top').height()
    })
    //   ▶︎ Smooth Scroll zu Sektionen
    $('.navigation_top a').on('touchstart click', function (e) {
        if ($('body').hasClass('rechtliches')) {
            e.preventDefault();
            document.location.href = "../index.php" + $(this).attr('href');
        } else {
            var $target = $(this.hash);
            $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
            if ($target.length) {
                var targetOffset = $target.offset().top - $('.navigation_top').height();
                $('html,body').animate({ scrollTop: targetOffset }, 1000);
                return false;
            }
        }
    });
    //! ▼ HAUPTMENUE END
    // ▼ HEADER 
    //   ▶︎ Manni-Ballons animieren
    var $factorsVertical = [3, 3, 2, 3, 1, 3, 2],
        $factorsHorizontal = [-3, -2, -1, 2, 1, 3, 2];
    $(window).scroll(function () {
        var $counter = 0;
        $('.manni-ballons .manni-ballon').each(function () {
            $counter++;
            $(this).css({
                'margin-bottom': $(window).scrollTop() * $factorsVertical[$counter - 1] * 0.25 + 'px',
                'margin-left': $(window).scrollTop() * $factorsHorizontal[$counter - 1] * 0.35 + 'px',
            });
        });
        if ($(window).scrollTop() < 240) {
            $('.manni-ballon.facebook').css({
                'margin-bottom': $(window).scrollTop() * 1 * 0.25 + 'px',
                'margin-left': $(window).scrollTop() * 0.5 * 0.35 + 'px',
                'position': 'absolute',
                'top': 'auto'
            });
        } else {
            $('.manni-ballon.facebook').css({
                'position': 'fixed',
                'margin-bottom': '0',
                'top': '-30px'
            });

        }
    });
    function initHeader() {
        var $factorsVertical = [3, 3, 2, 3, 1, 3, 2],
            $factorsHorizontal = [-3, -2, -1, 2, 1, 3, 2];
        if ($(window).scrollTop() < 240) {
            $('.manni-ballon.facebook').css({
                'margin-bottom': $(window).scrollTop() * 1 * 0.25 + 'px',
                'margin-left': $(window).scrollTop() * 0.5 * 0.35 + 'px',
                'position': 'absolute',
                'top': 'auto'
            });
        } else {
            $('.manni-ballon.facebook').css({
                'position': 'fixed',
                'margin-bottom': '0',
                'top': '-30px'
            });

        }
        var $counter = 0;
        $('.manni-ballons .manni-ballon').each(function () {
            $counter++;
            $(this).css({
                'margin-bottom': $(window).scrollTop() * $factorsVertical[$counter - 1] * 0.25 + 'px',
                'margin-left': $(window).scrollTop() * $factorsHorizontal[$counter - 1] * 0.35 + 'px',
            });

        })
    }
    //! ▼ HEADER END
    // ▼ MAIN 
    //   ▶︎ Programme
    // Vorhangsteuerung
    var $openCurtain = new Waypoint({
        element: $('#section_programme'),
        handler: function (direction) {
            if (direction == 'down') {
                $('.curtain').addClass("open");
            } else {
                $('.curtain').removeClass("open");
                document.querySelectorAll('video').forEach(vid => vid.pause());
                document.querySelectorAll('audio').forEach(aud => aud.pause());
            }
        },
        offset: $('.curtain__trigger_bottom').offset().top,
    })
    var $closeCurtain = new Waypoint({
        element: $('#section_persoenliches'),
        handler: function (direction) {
            if (direction == 'down') {
                $('.curtain').removeClass("open");
                document.querySelectorAll('video').forEach(vid => vid.pause());
                document.querySelectorAll('audio').forEach(aud => aud.pause());
            } else {
                $('.curtain').addClass("open");
            }
        },
        offset: $('.curtain__trigger_top').offset().top,
    })
    // Programmauswahl
    _N2.r('#n2-ss-2', function () {
        const slider = _N2['#n2-ss-2'];
        $('#section_programme a[href="#programme_manni"]').on('click', function (e) {
            e.preventDefault();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide(2);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
        $('#section_programme a[href="#programme_manni-und-moni"]').on('click', function (e) {
            e.preventDefault();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide(1);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
        $('.programmuebersicht').on('click', function (e) {
            e.preventDefault();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide(0);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
        $('.programmuebersicht-moni-und-manni').on('click', function (e) {
            e.preventDefault();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide(1);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
        $('.programmuebersicht-manni').on('click', function (e) {
            e.preventDefault();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide(2);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
        // Programmanzeige Manni
        $('.manni-button').on('click', function (e) {
            e.preventDefault();
            var $index = $(this).index();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide($index + 3);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
        // Programmanzeige Moni und Manni
        $('.programm_moni-und-manni').on('click', function (e) {
            e.preventDefault();
            var $index = $(this).index();
            $('#section_programme .curtain').removeClass('open');
            document.querySelectorAll('video').forEach(vid => vid.pause());
            document.querySelectorAll('audio').forEach(aud => aud.pause());
            setTimeout(function () {
                slider.slide($index + 11);
                $('#section_programme .curtain').addClass('open');
            }, 600);
        })
    })
    // Programm-Pointer
    $('.manni-button').on('mouseenter', function () {
        $('.programm-pointer_manni').css({
            'background-position': 'center ' + parseInt(($(this).index() + 1) * -500) + 'px'
        })
    })
    $('.manni-button').on('mouseleave', function () {
        $('.programm-pointer_manni').css({
            'background-position': 'center 0'
        })
    })
    //   ▶︎ Audio/Video pausieren sobald anderes Audio/Video wiedergegeben wird
    $('video').on('play', function() {
        document.querySelectorAll('audio').forEach(aud => aud.pause());
        var $currentlyPlaying = $(this);
        $('video').each(function() {
            $(this.removeClass('playing'));
        });
        $currentlyPlaying.addClass('playing');
        $('video').each(function() {
            if (!$(this).attr('class').contains('playing')) {
                $(this)[0].pause();
            }
        });
    })
    $('audio').on('play', function() {
        document.querySelectorAll('video').forEach(vid => vid.pause());
        var $currentlyPlaying = $(this);
        $('audio').each(function() {
            $(this.removeClass('playing'));
        });
        $currentlyPlaying.addClass('playing');
        $('audio').each(function() {
            if (!$(this).attr('class').contains('playing')) {
                $(this)[0].pause();
            }
        });
    })
    // Video 'Klein auf der Welt' anzeigen
    $('.klein-auf-der-welt__sign').on('click', function() {
        $('.klein-auf-der-welt__video').addClass('visible');
        $('.klein-auf-der-welt__video video')[0].play();
    })
    $('.klein-auf-der-welt__background').on('click', function() {
        $('.klein-auf-der-welt__video video')[0].pause();
        $('.klein-auf-der-welt__video').removeClass('visible');
    })
    var $closeHeaderVideo = new Waypoint({
        element: $('#section_termine'),
        handler: function (direction) {
            if (direction == 'down') {
                $('.klein-auf-der-welt__video video')[0].pause();
                $('.klein-auf-der-welt__video').removeClass('visible');
            } else {
            }
        },
    })
    //! ▼ MAIN END
});